/* ============================================================
   Kavera — front-end interactions
   Gallery · Tabs · FAQ accordions · synced bundle selection.
   Uses event delegation so it works no matter how the theme
   editor reorders or duplicates sections.
   ============================================================ */
(function () {
  'use strict';

  // Sections each load this script; run once no matter how many tags exist.
  if (window.__kaveraLoaded) return;
  window.__kaveraLoaded = true;

  /* ---- Gallery ----------------------------------------------------------- */
  function paintGallery(gallery) {
    var index = parseInt(gallery.getAttribute('data-index') || '0', 10);
    var thumbs = gallery.querySelectorAll('[data-kv-thumb]');
    var count = thumbs.length;
    if (!count) return;
    if (index < 0) index = count - 1;
    if (index >= count) index = 0;
    gallery.setAttribute('data-index', String(index));

    var active = thumbs[index];
    var main = gallery.querySelector('[data-kv-gallery-main]');
    if (main && active) {
      main.setAttribute('src', active.getAttribute('data-src') || '');
      main.setAttribute('alt', active.getAttribute('data-alt') || 'Product photo');
    }
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
    });
    var badge = gallery.querySelector('[data-kv-gallery-badge]');
    if (badge) badge.style.display = index === 0 ? '' : 'none';
  }

  function stepGallery(gallery, dir) {
    var index = parseInt(gallery.getAttribute('data-index') || '0', 10);
    gallery.setAttribute('data-index', String(index + dir));
    paintGallery(gallery);
  }

  /* ---- Tabs -------------------------------------------------------------- */
  function selectTab(tabs, index) {
    tabs.querySelectorAll('[data-kv-tab]').forEach(function (btn, i) {
      btn.classList.toggle('is-active', i === index);
    });
    tabs.querySelectorAll('[data-kv-panel]').forEach(function (panel, i) {
      panel.classList.toggle('is-active', i === index);
    });
    var panelWrap = tabs.querySelector('[data-kv-panels]');
    if (panelWrap) {
      // First tab's active state tucks the top-left corner under the tab.
      panelWrap.style.borderRadius = index === 0 ? '0 14px 14px 14px' : '14px';
    }
  }

  /* ---- Bundles (synced across every bundle group) ------------------------ */
  function selectBundle(index) {
    document.querySelectorAll('[data-kv-bundle]').forEach(function (card) {
      var i = parseInt(card.getAttribute('data-index') || '0', 10);
      card.classList.toggle('is-selected', i === index);
    });
    document.querySelectorAll('[data-kv-bundles]').forEach(function (group) {
      group.setAttribute('data-selected', String(index));
    });
  }

  /* ---- Add to cart -------------------------------------------------------- */
  function addSelectedBundle(button) {
    if (button.classList.contains('is-busy')) return;
    var group = button.closest('[data-kv-bundles]');
    if (!group) return;
    var selected = group.getAttribute('data-selected') || group.getAttribute('data-default') || '0';
    var card = group.querySelector('[data-kv-bundle][data-index="' + selected + '"]');
    var variantId = card ? parseInt(card.getAttribute('data-variant-id') || '', 10) : NaN;
    if (!variantId) {
      // Bundle not wired to a variant yet — send them to the cart as a fallback.
      window.location.href = '/cart';
      return;
    }

    var label = button.textContent;
    button.classList.add('is-busy');
    button.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        window.location.href = '/checkout';
      })
      .catch(function () {
        button.classList.remove('is-busy');
        button.textContent = label;
        window.alert('Sorry, something went wrong adding this to your cart. Please try again.');
      });
  }

  /* ---- Wire up ----------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var el;

    if ((el = e.target.closest('[data-kv-gallery-prev]'))) {
      stepGallery(el.closest('[data-kv-gallery]'), -1);
      return;
    }
    if ((el = e.target.closest('[data-kv-gallery-next]'))) {
      stepGallery(el.closest('[data-kv-gallery]'), 1);
      return;
    }
    if ((el = e.target.closest('[data-kv-thumb]'))) {
      var gallery = el.closest('[data-kv-gallery]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-kv-thumb]'));
      gallery.setAttribute('data-index', String(thumbs.indexOf(el)));
      paintGallery(gallery);
      return;
    }
    if ((el = e.target.closest('[data-kv-tab]'))) {
      var tabs = el.closest('[data-kv-tabs]');
      var btns = Array.prototype.slice.call(tabs.querySelectorAll('[data-kv-tab]'));
      selectTab(tabs, btns.indexOf(el));
      return;
    }
    if ((el = e.target.closest('[data-kv-faq-toggle]'))) {
      el.closest('[data-kv-faq-item]').classList.toggle('is-open');
      return;
    }
    if ((el = e.target.closest('[data-kv-bundle]'))) {
      selectBundle(parseInt(el.getAttribute('data-index') || '0', 10));
      return;
    }
    if ((el = e.target.closest('.kv-atc'))) {
      addSelectedBundle(el);
      return;
    }
  });

  /* ---- Init -------------------------------------------------------------- */
  function init() {
    document.querySelectorAll('[data-kv-gallery]').forEach(paintGallery);
    document.querySelectorAll('[data-kv-tabs]').forEach(function (tabs) {
      var def = parseInt(tabs.getAttribute('data-default') || '0', 10);
      selectTab(tabs, def);
    });
    var firstBundles = document.querySelector('[data-kv-bundles]');
    if (firstBundles) {
      selectBundle(parseInt(firstBundles.getAttribute('data-default') || '0', 10));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
